import React from 'react';
import AuthenticateContent from 'components/admin/manage/authenticate/AuthenticateContent';

export const AuthenticatePage: React.FC = () => {
  return <AuthenticateContent />;
};
